import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/styles/students.css";

// ✅ IMPORTANT: use your laptop IP (NOT localhost)
const API = "https://shuttle-craft-student-transport.onrender.com";

function Students() {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);

  // ✅ Fetch students (WORKS ON MOBILE + LAPTOP)
  useEffect(() => {
    fetch(`${API}/api/students`)
      .then((res) => res.json())
      .then((data) => {
        console.log("DATA:", data);
        setStudents(data);
      })
      .catch((err) => console.log("Error:", err));
  }, []);

  // ✅ Generate time slots
  const generateSlots = () => {
    const slots = [];

    for (let i = 4; i < 23; i++) {
      let next = i + 1;

      const format = (h) => {
        const period = h >= 12 ? "PM" : "AM";
        const hour = h % 12 === 0 ? 12 : h % 12;
        return `${hour}:00 ${period}`;
      };

      slots.push(`${format(i)} - ${format(next)}`);
    }

    return slots;
  };

  const timeSlots = generateSlots();

  // ✅ Assign student (UPDATED API)
  const assignStudent = async (id) => {
    const batch = document.getElementById(`batch-${id}`).value;
    const slot = document.getElementById(`slot-${id}`).value;
    const coach = document.getElementById(`coach-${id}`).value;

    try {
      await fetch(`${API}/api/students/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          batch,
          coach,
          slot,
        }),
      });

      alert("Saved Successfully");

      // ✅ Refresh data properly
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="students-page">
      <h2>Students Management</h2>

      <button className="add-btn" onClick={() => navigate("/register")}>
        + Add Student
      </button>

      <div className="table-wrapper">
        <table className="students-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Status</th>
              <th>Profile</th>
              <th>Batch</th>
              <th>Slot</th>
              <th>Coach</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {students.length === 0 ? (
              <tr>
                <td colSpan="9">No Data Found</td>
              </tr>
            ) : (
              students.map((student, index) => (
                <tr key={student._id}>
                  <td>{index + 1}</td>
                  <td>{student.name}</td>
                  <td>{student.phone}</td>
                  <td>{student.status || "Active"}</td>

                  <td>
                    <a
                      href={`/students/${student._id}`}
                      className="btn-profile"
                    >
                      View
                    </a>
                  </td>

                  <td>
                    <select id={`batch-${student._id}`}>
                      <option value="Beginner Level">Beginner Level</option>
                      <option value="Beginner Level 1">Beginner Level 1</option>
                      <option value="Beginner Level 2">Beginner Level 2</option>
                      <option value="Beginner Level 3">Beginner Level 3</option>
                      <option value="Intermediate">Intermediate</option>
                      <option value="Semi-Advanced">Semi-Advanced</option>
                      <option value="Advanced">Advanced</option>
                      <option value="Pro-Advanced">Pro-Advanced</option>
                      <option value="ONE-ON-ONE">ONE-ON-ONE</option>
                    </select>
                  </td>

                  <td>
                    <select id={`slot-${student._id}`}>
                      <option value="">Select Slot</option>

                      {timeSlots.map((slot, i) => (
                        <option key={i} value={slot}>
                          {slot}
                        </option>
                      ))}
                    </select>
                  </td>

                  <td>
                    <input
                      type="text"
                      placeholder="Coach"
                      id={`coach-${student._id}`}
                    />
                  </td>

                  <td>
                    <button
                      className="save-btn"
                      onClick={() => assignStudent(student._id)}
                    >
                      Save
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Students;